import { queryGet } from '@/api/apiConfig';

export default {
  loadSvg (url) {
    return queryGet(url).then((response) => response.data);
  },

  loadLocalSvg (file) {
    return fetch(file).then((response) => response.text());
  },

  loadLocalJacketBackgrounds (file) {
    return fetch(file).then((response) => response);
  }
};
